import { render, staticRenderFns } from "./IndicatorRegister.vue?vue&type=template&id=3de2bfb7"
import script from "./IndicatorRegister.vue?vue&type=script&lang=js"
export * from "./IndicatorRegister.vue?vue&type=script&lang=js"
import style0 from "./IndicatorRegister.vue?vue&type=style&index=0&id=3de2bfb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports